export const cleanAntdFormPayload = (obj: Record<string, any>): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([key]) => isNaN(Number(key))) // Remove numeric keys
      .map(([key, value]) => [
        key,
        value && typeof value === 'object' && !Array.isArray(value) // Recursively process nested objects
          ? cleanAntdFormPayload(value)
          : value === undefined
          ? null // Convert undefined to null
          : value,
      ]),
  );
};
